import React, { FC } from 'react';
import { Modal, Title, Button, Text, TitleRow } from './styles';
import useConnect from './connect';

type Props = {
  open: boolean;
  handleClose: () => void;
};

const BusyModeModal: FC<Props> = ({ open, handleClose }) => {
  const { handleEnable, isLoading } = useConnect(handleClose);
  return (
    <Modal showClose open={open} handleClose={handleClose}>
      <TitleRow>
        <Title>Are you sure?</Title>
        <Text>Turning this on will enable all channels at once.</Text>
      </TitleRow>
      <Button
        type="button"
        color="primary"
        variant="filled"
        fullWidth
        onClick={handleEnable}
        disabled={isLoading}
      >
        Apply Busy Mode
      </Button>
      <Button
        type="button"
        color="blank"
        variant="hard-outlined"
        fullWidth
        onClick={handleClose}
      >
        Cancel
      </Button>
    </Modal>
  );
};

export default BusyModeModal;
